module.exports = __webpack_public_path__ + "img/logo.2498b710.png";